import { InboxOutlined } from '@ant-design/icons-vue';
import InventoryItems from '@/views/products/InventoryItems.vue';
import UserInventoryList from '@/views/products/UserInventoryList.vue';

/** 背包物品（與商城管理同層級的獨立選單） */
export const inventoryFolderRoute = {
    path: 'inventory',
    name: 'Inventory',
    redirect: { name: 'InventoryItems' },
    meta: {
        title: '背包物品',
        icon: InboxOutlined
    },
    children: []
};

export const inventoryChildrenRoutes = [
    {
        path: 'items',
        component: InventoryItems,
        name: 'InventoryItems',
        meta: { title: '物品規格' }
    },
    {
        path: 'members',
        component: UserInventoryList,
        name: 'UserInventoryList',
        meta: { title: '會員背包' }
    },
    {
        path: 'redeem-scan',
        component: () => import('@/views/products/InventoryRedeemScan.vue'),
        name: 'InventoryRedeemScan',
        meta: { title: '兌換核銷' }
    }
];

/** 舊路徑相容：類型白名單已改掛系統營運 */
export const inventoryLegacyRedirects = [
    {
        path: '/inventory/item-types',
        redirect: { name: 'InventoryItemTypes' },
        meta: { hidden: true }
    },
    {
        path: '/products/inventory-items',
        redirect: { name: 'InventoryItems' },
        meta: { hidden: true }
    },
    {
        path: '/products/inventory-item-types',
        redirect: { name: 'InventoryItemTypes' },
        meta: { hidden: true }
    },
    {
        path: '/products/user-inventory',
        redirect: { name: 'UserInventoryList' },
        meta: { hidden: true }
    }
];
